import type { ActionCommandAutocompleteItem } from './actionCommandAutocompleteSource'

const EXACT_ACTION_COMMAND_BEFORE_CURSOR_PATTERN = /(?:^|[\s\n])!([A-Za-z0-9_.-]+)$/

export const exactActionCommandBeforeCursor = (
    textBeforeCursor: string,
    actionCommands: ActionCommandAutocompleteItem[],
): { item: ActionCommandAutocompleteItem; rawTag: string } | null => {
    const rawTag = textBeforeCursor.match(EXACT_ACTION_COMMAND_BEFORE_CURSOR_PATTERN)?.[1]
    if (!rawTag) return null

    const normalizedTag = rawTag.toLowerCase()
    const item = actionCommands.find(command => command.tag.toLowerCase() === normalizedTag)
    return item ? { item, rawTag } : null
}
